import { setChatChannels, setChannelUnreadMsgsStatus } from ".";
import axiosInstance from "../../../config/api";
import { setAppLoading } from "../generalSlice";

//thunk work
// showLoading: set to false for silent/background fetches so the global loader is not triggered
export const getMyChatChannels =
  (showLoading = true) =>
  async (dispatch) => {
    try {
      if (showLoading) {
        dispatch(setAppLoading(true));
      }

      const response = await axiosInstance.get("/chat/channel", null);
      if (response) {
        const channels = response?.data?.data?.chatChannels || [];
        dispatch(setChatChannels(channels));

        const user = JSON.parse(localStorage.getItem("user"));
        if (channels.length && user?.id) {
          let totalUnreadMsgs = 0;
          for (let i = 0; i < channels.length; i++) {
            const myMemberData = channels[i]?.chatMembers?.filter(
              (e) => e.memberId == user?.id,
            );
            if (myMemberData?.length) {
              totalUnreadMsgs += myMemberData[0].unreadMessageCount || 0;
            }
          }
          // Update the side-menu notification dot based on total unread count
          dispatch(setChannelUnreadMsgsStatus(totalUnreadMsgs > 0));
        } else {
          dispatch(setChannelUnreadMsgsStatus(false));
        }

        if (showLoading) {
          dispatch(setAppLoading(false));
        }
      }
    } catch (error) {
      console.log(error);
      if (showLoading) {
        dispatch(setAppLoading(false));
      }
    }
  };
